import { Avatar, Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

type Props = {
  participant: any | null;
  matchId?: string | number | null;
  showBackButton?: boolean;
  onBack?: () => void;
};

const MessagesThreadHeader = ({
  participant,
  matchId,
  showBackButton = false,
  onBack,
}: Props) => {
  return (
    <Box className={`messages-thread-header${showBackButton ? " is-mobile" : ""}`}>
      <Box className="messages-thread-user">
        {showBackButton && (
          <IconButton
            aria-label="Back to conversations"
            className="messages-thread-back"
            onClick={onBack}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <Avatar
          src={participant?.avatarUrl || undefined}
          alt={participant?.displayName || "User"}
        />
        <Box>
          <Typography fontWeight={600}>
            {participant?.displayName || "Unknown"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {matchId ? `Match ${matchId}` : "Active conversation"}
          </Typography>
        </Box>
      </Box>
      <IconButton aria-label="Conversation options" className="icon-muted">
        <MoreHorizIcon />
      </IconButton>
    </Box>
  );
};

export default MessagesThreadHeader;
